module.exports = __webpack_public_path__ + "img/33.5edccb97.jpg";